<template>
    <div id="content">
      <div id="pageContent">
        <div class="pageHeader">
          <div class="white flex flex-column hcenter" style="font-family: TruenoBd;padding-left: 10%;height: 100%">
            <div class="pageTitle">技术优势</div>
            <div class="subPageTitle">/TECHNOLOGY ADVANTAGE</div>
          </div>
        </div>
        <div class="tabs flex justify-spaceBetween vcenter ">
          <div class="flex1 t-right " >
            <span>您的位置：</span>
            <a href="/">首页 </a>
            <span>&gt; 技术优势</span>
          </div>
        </div>
        <div class="advantage mt4">
          <div class="white flex vcenter px2" style="font-family: TruenoBd;height: 100%">
            <div class="ml8 content" style="align-self:flex-start">
              <div class="pageTitle" style="color:#111D2B;font-size:32px !important">合成生物学技术平台</div>
              <div class="subPageContent mt6 contentText" style="font-size:16px !important">
                <p>〇 从自然界到生物基</p>
                <p>〇 智能生物实验平台 </p>
                <p class="contentTextIndet">〇 整合高通量微生物学、数据科学和人工智能、基因组工程和自动化技术，搭建模块化、高柔性、开放式的智能合成生物学平台</p>
              </div>
            </div>
            <div class="scale"><img class="advantage1" style="border-radius:10px" src="../assets/tech/advantage1.png"></div>
          </div>
        </div>
        <div class="advantage mt4" style="background: #F2F6FA;">
          <div class="white flex vcenter pt4 px2" style="font-family: TruenoBd;height: 100%;">
            <div class="ml8 mt2 content" style="width:45%;">
              <div class="pageTitle" style="color:#111D2B;font-size:32px !important">交互式发酵平台</div>
              <div class="subPageContent mt6 contentText"  style="font-size:16px !important">
                <p>〇 从微克到公吨</p>
                <p>〇 交互式发酵平台  </p>
                <p class="contentTextIndet">〇 从菌株开发 ,到规模化生产，实现闭环交互管理。数字化操控系统，可进行点对点、点对面的即时信息反馈。</p>
              </div>
            </div>
            <div style="width:632px"></div>
            <img class="advantage2 my4" src="../assets/tech/advantage2.png">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'About',
  methods: {
    // go(name) {
    //   var scrollTop = document.getElementById(name).scrollTop;
    // }
  }
}
</script>

<style lang="scss" scoped>
    .pageHeader{
        overflow: hidden; width: 100%; height: 494px;
        background-image: url("../assets/tech/banner.png");
        background-position: 100% 50%;
        background-size: cover;
    }
    .title {
      display: block;
      font-size: 43px;
      font-weight: 600;
      color: #111D2B;
      line-height: 1;
    }
    .info {
      color: #111D2B;
      opacity: 0.5;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
      line-height: 1.8;
      max-width: 800px;
      margin: 0 auto;
      margin-top: 21px;
    }
   .advantage{
      width: 100%;
      padding:89px 0;
      div{
        justify-content: center;
        .content{
          width: 45%;
        }

        flex-wrap: wrap;
        .pageTitle{
          font-size: 43px;
          font-weight: 600;
          color: #111D2B;
        }
        .subPageContent{
          font-size: 21px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          width: 90%;
        }
        
      }
    }
    .advantage2{
      width: 80%;
    }
   
    @media screen and (max-width: 1392px) {

      .advantage1{
        width: 90%;
      }
      .advantage2{
        width: 90%;
      }
      .advantage>div{
        justify-content: left;
      }
      .content{
        padding-left:0 !important;
        margin-left: 0% !important;
        width: 100% !important;
      }
      .subPageContent{
        width: 100%;
      }
      
    }
    @media screen and (max-width: 975px) {
      .advantage{
        padding: 0 10px !important;
      }
      .pageHeader{
        background-position: 73% 50%;
      }
    }
    
</style>



// WEBPACK FOOTER //
// src/views/tech.vue